import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container grid">
        <div>
          <h4>Company</h4>
          <p>Limitless Healthcare</p>
          <p>
            Survey No. 4/1B, Pisoli Undri Road, Behind Dharmavat
            Petroleum, Pune - 411060{" "}
          </p>
          <p>GST: 27AAJFL9715E1Z4</p>
          <p>Mon – Sat 9:00–19:00 IST</p>
        </div>
        <div>
          <h4>Contact</h4>
          <p>
            <a href="tel:+919022413416" aria-label="Call support">
              +91 9022413416
            </a>
          </p>
          <p>
            <a href="mailto:limitlesshealthcare10@gmail.com">
              limitlesshealthcare10@gmail.com
            </a>
          </p>
          <p>
            <a
              href="https://wa.me/919022413416"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp Chat
            </a>
          </p>
        </div>
        <div>
          <h4>Shop</h4>
          <ul>
            <li>
              {" "}
              <Link to="/safety">Safety Products</Link>
            </li>
            <li>
              {" "}
              <Link to="/disposable">Disposable Products</Link>
            </li>
            <li>
              {" "}
              <Link to="/surgical">Surgical Products</Link>
            </li>
            <li>
              {" "}
              <Link to="/furniture">Furniture</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="copy">© 2025 Limitless Healthcare</div>
      <style>{`
        .site-footer{background:#0a2230;color:#e6edf5;margin-top:24px}
        .grid{display:grid;grid-template-columns:2fr 2fr 2fr ;gap:16px;padding:28px 0}
        h4{margin:0 0 8px;color:#069ADD}
        a{color:#069ADD}
        .copy{border-top:1px solid rgba(255,255,255,.12);text-align:center;padding:12px 0;color:#cbd5e1}
        @media(max-width:960px){.grid{grid-template-columns:1fr 1fr}}
        @media(max-width:640px){.grid{grid-template-columns:1fr}}
      `}</style>
    </footer>
  );
}
